module.exports = __webpack_public_path__ + "static/media/fSilde2.d1956adf.png";